import React, { useState } from "react";

const ToolTip = ({ text, children, direction, alwaysVisible = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="my-tooltip-container"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {(isVisible || alwaysVisible) && (
        <div
          className={`${direction || "right"} my-tooltip ${
            alwaysVisible ? "always-visible" : ""
          }`}
        >
          <p>{text}</p>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
